import { useInjectReducer, useInjectSaga } from 'shared/lib/@reduxjs'

import { reducer, name } from './slice'
import { rootSaga } from './saga'

export function useEventResultsContainer() {
  useInjectReducer({ key: name, reducer })
  useInjectSaga({ key: name, saga: rootSaga })
}
